let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jYDLH")).then(() => parcelRequire('4TktE'));